const yaMetrikaId = 97940918
const url = new URL(location.href)
const domain = url.pathname.split('/')[1]
const baseParams = {
  url: url.toString(),
  domain,
}
const feedbackEvent = (event) => {
  window.ym(yaMetrikaId, 'reachGoal', `pres-feedback-${event}`, baseParams)
}

export const metrikaEvents = {
  clickOnShareon(platform) {
    window.ym(yaMetrikaId, 'reachGoal', `pres-shareon-${platform}`, baseParams)
  },
  clickOnOpenPres(version) {
    window.ym(yaMetrikaId, 'reachGoal', `pres-version-${version}`, baseParams)
  },
  onOpenFeedback() {
    return feedbackEvent('open')
  },
  onSendFeedback() {
    return feedbackEvent('send')
  },
  videoEvent(event) {
    window.ym(yaMetrikaId, 'reachGoal', `pres-video-${event}`, baseParams)
  },
  onChangeLanguage(from, to) {
    window.ym(yaMetrikaId, 'reachGoal', 'pres-language-change', {
      ...baseParams,
      from,
      to,
    })
  },
  onChangeImage(from, to) {
    window.ym(yaMetrikaId, 'reachGoal', 'pres-images-image-change', {
      ...baseParams,
      from,
      to,
    })
  },
  onChangeImagesTab(from, to) {
    window.ym(yaMetrikaId, 'reachGoal', 'pres-images-tab-change', {
      ...baseParams,
      from,
      to,
    })
  },
  onTapOnMap() {
    window.ym(yaMetrikaId, 'reachGoal', 'pres-map-click', baseParams)
  },
  onMapZoom(from, to) {
    window.ym(yaMetrikaId, 'reachGoal', 'pres-map-zoom', {
      ...baseParams,
      from,
      to,
    })
  },
  onPlatformLinkClick(feed, url) {
    window.ym(yaMetrikaId, 'reachGoal', 'report-platform-open', {
      ...baseParams,
      feed,
      url,
    })
  },
}
